<div class="container mt-4" style="min-height: calc(100vh - 300px);">
  <div class="">
    <div class="card">
      <div class=" card-header d-flex justify-content-between align-items-center">
        <h5 class="font-medium election-title">📄 Add Target</h5>
      </div>
      <div class="card-body">

        <form [formGroup]="targetForm" (ngSubmit)="getTargetDetail()">
          <div class="row align-items-end">

            <!-- Financial Year -->
            <div class="col-lg-4 col-md-6 mb-2">
              <label class="form-label">Financial/Reporting Year <span class="text-danger">*</span></label>
              <select class="form-control" formControlName="financialYear">
                <option value="">--Select--</option>
                <option *ngFor="let years of financialYears" [ngValue]="years">
                  {{ years?.financialYear }}
                </option>
              </select>
              <div *ngIf="targetForm.get('financialYear')?.touched && targetForm.get('financialYear')?.invalid"
                class="text-danger small">
                Financial year is required
              </div>
            </div>
            <div [ngSwitch]="this.UserDetails?.roleId" class="col-lg-4 col-md-6 mb-2">
              <!-- Circle Office -->
              <div *ngSwitchCase="1">
                <label class="form-label">Circle Office <span class="text-danger">*</span></label>
                <select class="form-control" formControlName="circleOffice">
                  <option value="">--Select--</option>
                  <option *ngFor="let circle of circlesList" [value]="circle?.iCircleId">
                    {{ circle?.sCircleName }}
                  </option>
                </select>
                <div *ngIf="targetForm.get('circleOffice')?.touched && targetForm.get('circleOffice')?.invalid"
                  class="text-danger small">
                  Circle office is required
                </div>
              </div>
              <!-- Block Office -->
              <div *ngSwitchDefault>
                <label class="form-label">Block Office <span class="text-danger">*</span></label>
                <select class="form-control" formControlName="blockOffice">
                  <option value="" selected>--Select--</option>
                  <option *ngFor="let circle of blockList" [value]="circle?.iBlockId">
                    {{ circle?.sBlockName }}
                  </option>
                </select>
                <div *ngIf="targetForm.get('blockOffice')?.touched && targetForm.get('blockOffice')?.invalid"
                  class="text-danger small">
                  block Office is required
                </div>
              </div>
            </div>
            <!-- Submit -->
            <div class="col-lg-4 text-end">
              <button type="submit" class="btn btn-primary" [disabled]="targetForm.invalid">
                Submit
              </button>
            </div>

          </div>
        </form>

      </div>
    </div>
  </div>
  <div class="container" *ngIf="months && this.UserDetails?.roleId !=11">

    <div class="card">
      <div class="card-header">
        <h5 class="m-0">📄 Target Assign</h5>
      </div>
      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-bordered text-center">
            <thead>
              <tr>
                <th *ngFor="let item of months">{{ item.sMonthName }}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td *ngFor="let item of months">
                  <span [class.text-success]="item.targetValue > 0" [class.text-danger]="item.targetValue === 0">
                    {{ item.targetValue }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- <div class="card">
    <div class="card-header">
      <h5 class="m-0">📄 Remaining Assign</h5>
    </div>
    <div class="card-body">
      <div class="table-responsive">
        <table class="table table-bordered text-center">
    <thead>
      <tr>
        <th>#</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>1</td>
      </tr>
    </tbody>
  </table>
      </div>
    </div>
  </div> -->
  </div>


  <form [formGroup]="tableForm" *ngIf="showTable">

    <div formArrayName="users" *ngIf="userFormArray.controls.length >0 ">
      <div class="card ">
        <div class="card-body" >
          <ng-container *ngIf="isVisible && (this.UserDetails?.roleId ==1 || this.UserDetails?.roleId ==13)">
 <div class="d-flex p-1  justify-content-end"> <a class="edit btn btn-info btn-sm" href="javascript:void(0);"  title="Edit"
              (click)="editMode()"> <i class="bi bi-pencil-square"></i></a>
            &nbsp;
            <a class="edit btn btn-info btn-sm" href="javascript:void(0);"  title="Submit Target" (click)="editTarget()"> <i
                class="bi bi-send"></i> </a>
          </div>
          </ng-container>
         
          <ngx-datatable class="ngx-datatable billdata colored-header sm table-striped table-hover" [rows]="rows"
            [columns]="columns" [columnMode]="'force'" [headerHeight]="50" [footerHeight]="50" rowHeight="auto"
            [virtualization]="false" [scrollbarV]="false" [scrollbarH]="true" [limit]="12">
            <!-- Sr.No -->
            <ngx-datatable-column name="Sr.No" [maxWidth]="50">
              <ng-template let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>
                <div [formGroupName]="rowIndex">
                  {{ rowIndex + 1 }}
                </div>
              </ng-template>
            </ngx-datatable-column>

            <!-- First Name -->
            <ngx-datatable-column name="year">
              <ng-template let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>
                <div [formGroupName]="rowIndex">
                  <ng-container>
                    <!-- <input class="form-control" formControlName="FirstName" placeholder="FirstName*" />
                <div *ngIf="row.get('FirstName')?.invalid && (row.get('FirstName')?.touched )">
                  <small class="text-danger" *ngIf="row.get('FirstName')?.errors?.['required']">
                    First name is required.
                  </small>
                </div> -->
                    {{ row.get('year')?.value }}

                  </ng-container>
                  <!-- <ng-template #displayFirstName>{{ row.get('year')?.value }}</ng-template> -->
                </div>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="target">
              <ng-template let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>
                <div [formGroupName]="rowIndex">
                  <ng-container *ngIf="editIndex; else displayFirstName">
                    <input class="form-control" type="text" formControlName="target"
                      (input)="allowOnlyInteger($event, 3)" placeholder="Enter target" />
                    <div *ngIf="row.get('target')?.invalid && (row.get('target')?.touched )">
                      <small class="text-danger" *ngIf="row.get('target')?.errors?.['required']">
                        target is required.
                      </small>
                    </div>
                  </ng-container>
                  <ng-template #displayFirstName>{{ row.get('target')?.value }}</ng-template>
                </div>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="remainingTarget" *ngIf="this.UserDetails?.roleId == 13">
              <ng-template let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>
                <div [formGroupName]="rowIndex">
                  <ng-container>

                    {{ row.get('remainingTarget')?.value }}

                  </ng-container>
                </div>
              </ng-template>
            </ngx-datatable-column>

          </ngx-datatable>
        </div>
      </div>

    </div>
  </form>

</div>